export interface Photo {
    id?: number;
    originalUrl: string | null;
    focusX: number;
    focusY: number;
    srcset: Srcset;
}

interface Srcset {
    [size: string]: string;
}

export function srcsetToHtmlString(srcset: Srcset): string {
    return Object.entries(srcset).reduce<string>(((previousValue, [size, url]) => {
        return previousValue.length ? `${previousValue}, ${url} ${size}` : `${url} ${size}`;
    }), '');
}

export function highestWidthSrcsetSrc(srcset: Srcset): string {
    return srcset[Object.entries(srcset).reduce<string>(((previousValue, [size, _]) => {
        const previousNumber = +previousValue.replace(/[^\d]/g, '');
        const sizeNumber = +size.replace(/[^\d]/g, '');

        if (previousNumber < sizeNumber) {
            return size;
        }

        return previousValue;
    }), '0')];
}
